module.exports = __webpack_public_path__ + "static/media/circle.2841c79f.svg";